import { ISortPackageJsonScriptsOptions } from './lib/types';
import sortPackageJsonScripts from './lib/sortScripts';

export type { ISortPackageJsonScriptsOptions } from './lib/types';

export { sortPackageJsonScripts }

export default sortPackageJsonScripts;
